var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Card, Col, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { i18n } from '../../../../translations';
import { GroupAnalyticsNewTKeys } from '../../../../translations/keys';
import Chart from 'react-apexcharts';
import Colors from '../../../../constants/Colors';
var MachinesByTypeCard = function (props) {
    var _a = __read(useState(true), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState([]), 2), pieData = _b[0], setPieData = _b[1];
    var capitalizeFirstLetter = function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var getMachineTypesPieData = function (data) {
        var pieData1 = [];
        data.forEach(function (machine) {
            var found = pieData1.find(function (pieItem) { return pieItem.x === machine.equipment_type; });
            if (found) {
                found.y = found.y + 1;
            }
            else {
                pieData1.push({
                    x: machine.equipment_type,
                    y: 1,
                });
            }
        });
        setPieData(pieData1.sort(function (a, b) { return a.y - b.y; }));
        setLoading(false);
    };
    useEffect(function () {
        if (!props.loading) {
            setLoading(true);
            getMachineTypesPieData(props.equipments && Object.values(props.equipments));
        }
    }, [props.loading, props.equipments]);
    return (React.createElement(Col, { span: 12 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { className: "number-of-equipment-by-type-card", title: i18n.t(GroupAnalyticsNewTKeys.numberOfMachineByType), headStyle: { fontSize: '16px' }, bodyStyle: { height: '100%' } },
                React.createElement("div", { className: "scrollable" },
                    React.createElement(Chart, { options: {
                            dataLabels: {
                                enabled: false,
                            },
                            colors: Colors,
                            labels: pieData.map(function (a) { return capitalizeFirstLetter(a.x); }),
                            legend: {
                                inverseOrder: true,
                                formatter: function (val, opts) {
                                    return (val +
                                        ' - ' +
                                        opts.w.globals.series[opts.seriesIndex]);
                                }
                            }
                        }, series: pieData.map(function (a) { return a.y; }), type: "pie", height: 200 }))))));
};
export default MachinesByTypeCard;
